import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {apiRequest} from "../../components/Utils/SimmsUtils";

async function getCodes() {
    try{
        return  await needAuth.get('/codes');
    }catch (error){
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

async function selectCodesByParentId(parentId, success) {
    return apiRequest(() => needAuth.get(`/codes/parents/${parentId}`), success);
}

const getFlatCodes = async (parentId) => {
    try{
        return await needAuth.get(`/codes/${parentId}/flat`);
    }catch (error){
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

async function saveCode(data, success, duplicated, failure) {
    return apiRequest(() => needAuth.post(`/codes`, data), success, duplicated, failure);
}

export async function createCode(data) {
    return await needAuth.post(`/codes`, data);
}

export async function modifyCode(data) {
    return await  needAuth.put(`/codes`, data);
}

async function deleteCode(codeId, success, failure) {
    return apiRequest(() => needAuth.delete(`/codes/${codeId}`), success, failure);
}

async function updateCode(data, success, duplicated) {
    return apiRequest(() => needAuth.put(`/codes`, data), success, duplicated);
}

async function updateCodeName(data, success, duplicated) {
    return apiRequest(() => needAuth.put(`/codes/name`, data), success, duplicated);
}

export {
    getCodes, selectCodesByParentId, getFlatCodes,
    saveCode, deleteCode, updateCodeName,
    updateCode
};